module.exports = __webpack_public_path__ + "img/kaist_gallery1.7d8139c6.jpg";